import React from 'react'
import Navbar from '../Components/Navbar'
import AboutComponent from '../Components/AboutComponent'
import Footer from '../Components/Footer'

const About = () => {
  return (
    <div>
      <Navbar />
      <AboutComponent />
      <Footer />
    </div>
  )
}

export default About